/* ============================================================
   VIBEE — Minimum order quantity
   File: assets/vibee-min-qty.js
   Load from layout/theme.liquid (defer).

   Kaam:
   1. PDP par quantity input ko min se neeche nahi jaane deta
   2. Add to cart se pehle clamp karta hai
   3. Cart page + cart drawer me bhi clamp (Dawn ke apne
      change handler se PEHLE, capture phase par)
   4. Har cart re-render ke baad dobara apply hota hai

   Min value aati hai:
   - PDP:  input[data-vibee-min]
   - Cart: input[data-vibee-min]  (cart-drawer.liquid /
           main-cart-items.liquid me add karna hai)
   ============================================================ */
(function () {
  'use strict';

  var SEL = 'input[data-vibee-min]';

  function readMin(input) {
    var n = parseInt(input.getAttribute('data-vibee-min'), 10);
    return isNaN(n) || n < 1 ? 1 : n;
  }

  /* Browser stepper aur minus button dono min respect karein */
  function syncAttrs(input) {
    var min = readMin(input);
    if (min <= 1) return;
    if (parseInt(input.getAttribute('min'), 10) !== min) {
      input.setAttribute('min', String(min));
    }
    input.setAttribute('data-min', String(min));
  }

  /* Value ko min tak uthao. Cart me 0 allowed hai (= remove). */
  function clamp(input, allowZero) {
    var min = readMin(input);
    if (min <= 1) return false;

    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = min;

    if (allowZero && val === 0) return false;
    if (val >= min) return false;

    input.value = String(min);
    flash(input);
    return true;
  }

  /* Chhota visual feedback jab value uthai gayi ho */
  function flash(input) {
    var box = input.closest('.quantity') || input;
    box.classList.add('vibee-minqty-bump');
    setTimeout(function () {
      box.classList.remove('vibee-minqty-bump');
    }, 600);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SEL).forEach(syncAttrs);
  }

  /* ---------- capture phase: Dawn ke handlers se pehle ---------- */
  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input.matches || !input.matches(SEL)) return;
      var isCart = input.name === 'updates[]';
      clamp(input, isCart);
    },
    true
  );

  /* Typing ke waqt sirf attribute sync, clamp change par hi */
  document.addEventListener(
    'focusout',
    function (e) {
      var input = e.target;
      if (!input.matches || !input.matches(SEL)) return;
      clamp(input, input.name === 'updates[]');
    },
    true
  );

  /* ---------- Add to cart guard ---------- */
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.product-form__submit');
      if (!btn) return;

      var form = btn.closest('form') || document.getElementById(btn.getAttribute('form'));
      var input =
        (form && form.querySelector(SEL)) ||
        document.querySelector('product-info ' + SEL);

      if (input) clamp(input, false);
    },
    true
  );

  /* ---------- boot + cart re-render ---------- */
  function boot() {
    initAll();

    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var n = records[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches(SEL)) syncAttrs(n);
          else initAll(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();
